import { allPermissions } from '../general/utils/authHelper';
import Permission from '../shared/constants/Permission';
import { auditAccessContextLoader } from './loaders';

const AuditAccessPage = () => import('./views/AuditAccessPage.vue');

export default [
  {
    path: '/audit-access',
    name: 'audit-access',
    component: AuditAccessPage,
    meta: {
      title: 'auditAccess.pageTitle',
      hasAccess: allPermissions(Permission.WARRANTY_TEAM_MEMBER),
      logicalModule: 'audit-access',
    },
    props: {
      context: auditAccessContextLoader,
    },
  },
];
